import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/scrollToTop";
import Layout from "./layout/layout";
import Error from "./pages/404";
import Cookies from "universal-cookie";
import Consumo from "./pages/Consumo";
import ConsumoPreciosAnteriores from "./pages/ConsumoPreciosAnteriores";
import ConsumoPrecioYear from "./pages/ConsumoPrecioYear";
import ConsumoEstadisticas from "./pages/ConsumoEstadisticas";
import ConsumoEstadisticasMonths from "./pages/ConsumoEstadisticasMonths";
import ConsumoLiquidaciones from "./pages/ConsumoLiquidaciones";
import ConsumoLiquidacionesInformes from "./pages/ConsumoLiquidacionesInformes";
import ConsumoLiquidacionesInforme from "./pages/ConsumoLiquidacionesInforme";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: "p",
      logged: false,
    };
  }

  handleUser = (e, c, t, m, l) => {
    const cookies = new Cookies();
    cookies.set("user", e, { path: "/" });
    cookies.set("lastName", l, { path: "/" });
    cookies.set("token", t, { path: "/" });
    cookies.set("mail", m, { path: "/" });

    this.setState(
      (this.state = {
        ...this.state,
        logged: c,
        userName: e,
        token: t,
        userMail: m,
        lastName: l,
      })
    );
  };

  handleLogout = (url) => {
    const cookies = new Cookies();

    cookies.remove("user", { path: "/" });
    cookies.remove("token", { path: "/" });
    cookies.remove("mail", { path: "/" });
    cookies.remove("lastName", { path: "/" });

    this.setState(
      (this.state = {
        ...this.state,
        logged: false,
        userName: " ",
        lastName: " ",
      })
    );

    if (url !== undefined) {
      window.location.href = "/login?u=" + url;
    } else {
      window.location.href = "/login";
    }
  };

  componentDidMount() {
    const cookies = new Cookies();

    let usuarioCookie = cookies.get("user");
    let usuarioToken = cookies.get("token");
    let mailToken = cookies.get("mail");
    let lastName = cookies.get("lastName");

    if (usuarioCookie) {
      this.setState({ userName: usuarioCookie });
      this.setState({ logged: true });
    }
    if (usuarioToken) {
      this.setState({ token: usuarioToken });
    } else {
      this.setState({ logged: false });
    }
    if (mailToken) {
      this.setState({ userMail: mailToken });
    } else {
      this.setState({ logged: false });
    }
    if (lastName) {
      this.setState({ lastName: lastName });
    } else {
      this.setState({ logged: false });
    }
  }

  render() {
    return (
      <BrowserRouter>
        <Layout data={this.state} handleLogout={this.handleLogout}>
          <ScrollToTop />
          <Routes>
            <Route exact path="/" element={<Consumo userMail={this.state.userMail} />} />
            <Route
              exact
              path="/consumo/precios-anteriores"
              element={<ConsumoPreciosAnteriores userMail={this.state.userMail} />}
            />
            <Route
              exact
              path="/consumo/precios-anteriores/:year"
              element={<ConsumoPrecioYear userMail={this.state.userMail} />}
            />
            <Route
              exact
              path="/consumo/estadisticas"
              element={<ConsumoEstadisticas userMail={this.state.userMail} />}
            />
            <Route
              exact
              path="/consumo/estadisticas/:year/m/:month"
              element={<ConsumoEstadisticasMonths userMail={this.state.userMail} />}
            />
            <Route
              exact
              path="/consumo/liquidaciones"
              element={<ConsumoLiquidaciones userMail={this.state.userMail} />}
            />
            <Route
              exact
              path="/consumo/liquidaciones/:user/informes"
              element={<ConsumoLiquidacionesInformes userMail={this.state.userMail} />}
            />
            <Route
              exact
              path="/consumo/liquidaciones/:user/informes/:informe/f/:fecha"
              element={<ConsumoLiquidacionesInforme userMail={this.state.userMail} />}
            />
            <Route path="*" element={<Error />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    );
  }
}

export default App;
